export default function maskPhone(phoneNumber) {
  const lastTwoDigits = phoneNumber.slice(-2);

  return `(***) ***-**${lastTwoDigits}`;
}

